import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import { Map } from 'immutable';
import { compose, withProps } from 'recompose';

import * as styles from './styles.css';
import propsEqual from '../../../lib/propsEqual';

function CalendarDate({
  date,
  selected,
  highlighted,
  onClick,
  holiday,
  variant,
  activePast,
  periodHighlights,
  withPeriods,
  hasSplittedDay,
}) {
  const dateMoment = moment(date);
  const referenceDateMoment = moment();
  const classes = classNames(
    {
      [styles.selected]: selected,
      [styles.notSelected]: !selected,
      [styles.highlighted]: highlighted === true,
      [styles.notHighlighted]: highlighted === false,
      [styles.pastDateCell]: !activePast ?
        dateMoment.isBefore(referenceDateMoment, 'day')
        : dateMoment.isAfter(referenceDateMoment, 'day'),
      [styles.currentDateCell]: dateMoment.isSame(referenceDateMoment, 'day'),
      [styles.holiday]: !!holiday,
      [styles.withPeriods]: withPeriods,
    },
    styles.dateCell,
    styles[variant],
  );

  return (
    <td
      onClick={() => onClick(date)}
      className={classes}
      data-testid="calendarDate"
    >
      <div
        className={styles.text}
        title={holiday ? holiday.name : undefined}
      >
        {dateMoment.date()}
      </div>
      {withPeriods && (
        <div className={styles.deviationParts}>
          {periodHighlights && periodHighlights.map(({ name, background }, index) => {
            const style = index === 0 || index === periodHighlights.size - 1
              ? { flex: hasSplittedDay ? 0.5 : 1 } : { flex: 1 };
            return (
              <div
                key={`${date}_${name}`}
                style={{ ...style, background }}
                className={classNames(
                  styles.deviationPart,
                )}
                title={name}
              />
            );
          })}
        </div>
      )}
    </td>
  );
}

CalendarDate.defaultProps = {
  highlighted: undefined,
  holiday: undefined,
  activePast: false,
  periodHighlights: undefined,
  withPeriods: false,
  hasSplittedDay: false,
};

CalendarDate.propTypes = {
  date: PropTypes.string.isRequired,
  highlighted: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  holiday: PropTypes.shape({
    date: PropTypes.string,
    name: PropTypes.string,
  }),
  variant: PropTypes.string.isRequired,
  activePast: PropTypes.bool,
  periodHighlights: PropTypes.instanceOf(Map),
  withPeriods: PropTypes.bool,
  hasSplittedDay: PropTypes.bool,
};

export { CalendarDate as CalendarDateTest };
export default compose(
  withProps(({ date, allPeriodHighlights }) => ({
    periodHighlights: allPeriodHighlights ? allPeriodHighlights.get(date) : undefined,
  })),
  propsEqual([
    'date',
    'selected',
    'highlighted',
    'onClick',
    'holiday',
    'variant',
    'activePast',
    'periodHighlights',
    'withPeriods',
    'hasSplittedDay',
  ]),
)(CalendarDate);
